import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'
import { setStep } from '../../../modules/registration/actions/creators'
import {
  setAccessToken,
  setAuthRequestData,
  setLoginRequestId,
  setLoginStep,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'
import { setLoyaltyPoints } from '../../../modules/loyalty/actions/creators'
import {
  setPrimaryInfo,
  setPreferenceIds,
} from '../../../modules/profile/actions/creators'
import { setAccountStatus } from '../../../modules/profile/actions/creators'
import { setFirstSpinModalOpen } from '../../../modules/gamification/actions/creators'
import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doGetFirebaseToken,
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const { auth } = reduxState
  const {
    authRequestData,
    loginStep,
    loginRequestId,
    redirectAfterAuth,
    firebaseMessagingToken,
  } = auth

  return {
    authRequestData,
    loginStep,
    loginRequestId,
    redirectAfterAuth,
    firebaseMessagingToken,
    doGetFirebaseToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccessToken,
      setPreferenceIds,
      setAuthRequestData,
      setLoginRequestId,
      setLoginStep,
      setStep,
      replace,
      setLoyaltyPoints,
      setPrimaryInfo,
      setFirebaseMessagingToken,
      saveAccessToken,
      setAccountStatus,
      setFirstSpinModalOpen,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
